import {Component, Input} from '@angular/core';
import {SummedMasterReport} from '../../shared/domain/report/summed-master-report.model';
import {RolePermission} from '../../../shared/auth/rbac/role-permission';

@Component({
  selector: 'cm-kn-dashboard-metric-boxes',
  templateUrl: `./kn-dashboard-metric-boxes.component.html`,
  styleUrls: ['./kn-dashboard-metric-boxes.component.scss'],
  host: {'class': 'cm-kn-dashboard-metric-boxes'}
})
export class KnDashboardMetricBoxesComponent {

  @Input()
  loading = false;

  @Input()
  data: SummedMasterReport;

  RolePermission = RolePermission;

  showRevenueBreakdown = false;

  constructor() {
  }

}
